export default __webpack_public_path__ + "static/media/Ballroll_00295.68f92821.png";